import { CloseOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import * as React from "react";
import { ZOption } from "src/types/ZOption";

import * as styles from "./MultiSelectDropdownFilter.module.less";

// TODO: пока считаем, что value: string

type PropsMultiSelectDropdownFilter = {
  currentValue: string[] | null | undefined;
  apply: (value: string[] | undefined) => void;
  cancel: () => void;
  options: ZOption[];
};

export const MultiSelectDropdownFilter: React.FC<
  PropsMultiSelectDropdownFilter
> = (props) => {
  const { currentValue, cancel, apply, options } = props;
  const [value, setValue] = React.useState<string[]>([]);
  React.useEffect(() => {
    setValue(currentValue ?? []);
  }, [currentValue]);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={styles.box}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.content}>
        <div>
          <Select
            allowClear
            mode="multiple"
            options={options}
            style={{ width: "100%" }}
            value={value}
            onChange={(v) => setValue(v)}
          />
        </div>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={cancel}
        />
      </div>
      <div className={styles.buttons}>
        <div className={styles.left}>
          <Button onClick={() => apply(undefined)} disabled={!value?.length}>
            Очистить
          </Button>
        </div>
        <Button type="primary" onClick={() => apply(value)}>
          Применить
        </Button>
      </div>
    </div>
  );
};
